module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel02_1280_1280_ko-2e84180053f1212a3540f01baf20c722.jpg";